import { memo } from 'react';
import { Flex } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { getPlannerBlock } from 'redux/PlannerModeSlice';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from './constants';
import BaselineScenarioDropdown from './components/BaselineScenarioDropdown';
import BlockDimensionsDropdown from './components/BlockDimensionsDropdown';
import BlockTitle from './components/BlockTitle';
import BuilderModeToggle from './components/BuilderModeToggle';

const BuilderModePageHeader = memo(() => {
  const plannerBlock = useSelector(getPlannerBlock);
  const title = plannerBlock?.name ?? 'Block';

  return (
    <Flex
      as='header'
      w='100%'
      align='center'
      justify='space-between'
      flexWrap={{ base: 'wrap', lg: 'nowrap' }}
      gap={{ base: 4, md: BUILDER_MODE_V1_LAYOUT.titleActionsGap }}
      bg={BUILDER_MODE_V1_TOKENS.white}
      borderBottom='1px solid'
      borderColor={BUILDER_MODE_V1_TOKENS.border}
      pt={BUILDER_MODE_V1_LAYOUT.paddingTop}
      pb={BUILDER_MODE_V1_LAYOUT.paddingBottom}
      px={BUILDER_MODE_V1_LAYOUT.horizontalPadding}
    >
      <Flex align='center' gap={BUILDER_MODE_V1_LAYOUT.titleActionsGap} flexWrap='wrap' minW={0}>
        <BlockTitle title={title} />
        <Flex align='center' gap={BUILDER_MODE_V1_LAYOUT.actionsGap} flexWrap='wrap'>
          <BaselineScenarioDropdown />
          <BlockDimensionsDropdown />
        </Flex>
      </Flex>
      <BuilderModeToggle />
    </Flex>
  );
});

BuilderModePageHeader.displayName = 'BuilderModePageHeader';

export default BuilderModePageHeader;
